/*
 * @Author: lzy
 * @Date: 2019-12-20 11:28:37
 * @LastEditTime: 2021-07-16 16:18:58
 * @LastEditors: cc
 * @FilePath: \xjmediacloud\app\editingCenter\qiehao\toBeCompiled\toBecompiled.js
 * @Description: 百家号待编
 */
'use strict';
angular.module('editQiehaoToBeCompiledModule', ['editQiehaoToBeCompiledRouterModule']).controller('EditQiehaoToBeCompiledCtrl', [
    '$scope',
    '$state',
    'qiehaoService',
    'qieConst',
    'editingMediatype',
    function($scope, $state, qiehaoService, qieConst, editingMediatype) {
        initStatus();
        initDropDown();

        /**
         * [initStatus description]初始化状态
         * @return {[type]} [description]
         */
        function initStatus() {
            $scope.parentStatus = {
                Classify: 'kuaibao.daibian',
                storageName: 'qiehao', // 监听缓存的名字
                idName: qieConst.idName, // 主要使用ID的名称
                mediaType: editingMediatype.qiehao, // 渠道类型
                typeConst: qieConst,
                buttonCheck: {
                    name: 'kuaibao',
                    type: 'daibian',
                }, // 渠道特有数据
                isEssearch: false,
                checkList: {}, // 按钮权限判断
                editPath: {
                    1: 'qiehaonews',
                    2: 'qiehaoatlas',
                    7: 'qiehaovideo',
                },
            }; // 表示为父控制器的状态位
            $scope.data = {
                selectedArray: [],
                docTypeJsons: [], // 稿件类型
                selectedDocType: {}, // 选中的稿件类型
                trench: qieConst.listenStroageKey,
            };
            $scope.params = {
                serviceid: 'mlf_kuaibaoarticle',
                methodName: 'queryToBeCompiledDoc',
                AccountID: $state.params.account,
            }; // 请求列表的参数
            $scope.graphParams = qieConst.graph; // 请求图示所需的参数
        }

        /**
         * [initDropDown description]初始化下拉框
         *
         * @return  {[type]}  [return description]
         */
        function initDropDown() {
            $scope.data.docTypeJsons = qiehaoService.initSelect();
            $scope.data.selectedDocType = angular.copy($scope.data.docTypeJsons[0]);
            // editingCenterService.dealStorage($scope);
        }
    },
]);
